//** NEW TEMPLATE
import React, { useEffect, useState, useCallback, useRef, useDebugValue } from "react";
import { withRouter, Link } from "react-router-dom";
import Routes from "../../Routes";
import { renderLangString } from "../../languageStrings";
import { injectIntl } from "react-intl";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// HOC
import NewAppHOC from "../../hoc/NewAppHOC";

// FUNCTIONS
import AJAX from "../../functions/ajax";
import S from "../../functions/select";
import validateData from "../../functions/validateData";

// GLOBALS
import GLOBALS from "../../globals/index";

// COMPONENTS
import MainAsideNav from "../../components/navigations/MainAsideNav";
import HelperAsideNav from "../../components/navigations/HelperAsideNav";
import ListNav from "../../components/navigations/ListNav";
import CarouselNav from "../../components/navigations/CarouselNav";
import Main from "../../components/main/Main";
import DisplayScore from "../../components/display/DisplayScore";
import TogglePrompt from "../../components/prompt/TogglePrompt";
import Overview from "../../components/display/Overview";
import NewButton from "../../components/buttons/NewButton";
import AnimateLayout from "../../components/layout/AnimateLayout";
import Title from "../../components/text/Title";
import FormioForm from "../../components/forms/FormioForm";
import Layout from "../../components/layout/Layout";
import Icon from "../../components/icons/Icon";

// DATA MODEL
import caseDataModel from "../../data_model/reviewer/case/case_data";
import ContentAccordion from "../../components/display/ContentAccordion";

function Case({ match, info, intl }) {
  const isInitialMount = useRef(false);
  const _id = 789028790372970;
  let scrollTimeout;
  const dispatch = useDispatch();
  const displayScore = useRef();
  let asideMenuContent = null;
  let displayScoreWidth = null;

  const [counterData, setCounterData] = useState();
  const [activeCase, setActiveCase] = useState(null);
  const [isCounterDone, setIsCounterDone] = useState(false);
  const [isExcluded, setIsExcluded] = useState();
  const [savedStatus, setSavedStatus] = useState(false);
  const reduxState = useSelector(state => state);
  const reviewer = useSelector(state => state.reviewer);
  const sizeOfTheScreen = useSelector(state => state.app.sizeOfTheScreen);

  // on route change
  useEffect(() => {
    if (isInitialMount.current) {
      setActiveCase(null);
      setSavedStatus(false);
      GLOBALS.caseNavMounted = false;
      getMainData();
    } else {
      isInitialMount.current = true;
    }

    let scoreCon = document.getElementById("483864876597484");
    if (scoreCon) {
      unfixTopEl(scoreCon);
    }
  }, [match]);

  // on unmount
  useEffect(() => {
    return () => {
      dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_NOT_PRESENT });
    };
  }, []);

  const getMainData = () => {
    AJAX()
      .getReviewCase(_id, reduxState, Routes.getData().activeUrlLastParam)
      .then(res => {
        const isDataValid = validateData(
          "Reviewer > Case > AJAX().getReviewCase",
          res,
          caseDataModel
        );

        if (isDataValid) {
          const activeCaseData = res.data.case;

          setActiveCase(activeCaseData);
          setIsExcluded(activeCaseData.excluded);

          dispatch({
            type: ACTIONS.SET_PAGE_IDS,
            payload: { stage: activeCaseData.stage_id, collection: activeCaseData.collection_id },
          });

          setCounterData({
            active: activeCaseData.in_range == 0 ? true : false,
            end_at: activeCaseData.end_at, //new Date().setSeconds(new Date().getSeconds() + 10), //
            start_at: activeCaseData.start_at,
            toWhat: renderLangString({ id: "$_d9" }),
          });
        }
      });
  };

  const toggleAllCases = () => {
    if (sizeOfTheScreen && sizeOfTheScreen === "desktop") {
      dispatch({ type: ACTIONS.TOGGLE_HELLPER_SIDE_NAV });
    }

    if (sizeOfTheScreen && sizeOfTheScreen === "mobile") {
      dispatch({ type: ACTIONS.SHOW_HELPER_NAV_ON_TOP });
      dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
    }
  };

  const toggleHelperNav = e => {
    if (e.key === "Enter") {
      if (!reduxState.app.helperSideNavToggle) {
        setTimeout(() => {
          S("#btn-390481094")[0].focus();
        }, 200);
      }
    }
  };

  const handleExcludion = () => {
    AJAX()
      .patch(_id, activeCase.apis.toggle_x.api.url, {})
      .then(res => {
        if (res.data.result.self_excluded) {
          setIsExcluded(true);
        } else if (!res.data.result.self_excluded) {
          setIsExcluded(false);
        }
        getMainData();
      })
      .catch(err => console.log(err));
  };

  const handleFormChange = res => {
    setSavedStatus("saving");
  };

  const handleFormSave = res => {
    // on form submit
    setSavedStatus("saved");
    getMainData();
  };

  const handleNavItemClick = () => {
    dispatch({ type: ACTIONS.HIDE_HELPER_NAV_ON_TOP });
  };

  const handleCaroselClick = () => {
    setActiveCase(null);
    setSavedStatus(false);
    // scroll active manu item into the view
    scrollTimeout = setTimeout(() => {
      const activItem = document.querySelector(".listNav_active");
      if (activItem) activItem.scrollIntoView();
    }, 300);

    window.location.reload();
  };

  const handleCounterEnd = () => {
    setIsCounterDone(true);
  };

  const handleScroll = e => {
    const displayScoreCon = document.getElementById("displayScoreCon_12390u13");

    if (!asideMenuContent) {
      displayScore.current = document.getElementById("483864876597484");
      asideMenuContent = document.getElementById("__n_6789689687698");
    } else {
      const asideMenuContentInfo = asideMenuContent.getBoundingClientRect();

      if (asideMenuContentInfo.top + 70 <= 0) {
        if (displayScoreWidth === null) {
          displayScoreWidth = displayScore.current.getBoundingClientRect().width;
        }
        fixToTop(displayScore.current, displayScoreWidth);
        if (displayScoreCon) displayScoreCon.style.height = "3.7rem";
      } else {
        unfixTopEl(displayScore.current);
        if (displayScoreCon) displayScoreCon.style.height = "unset";
      }
    }
  };

  const fixToTop = (el, elWidth) => {
    el.style.width = `${elWidth}px`;
    el.style.position = "fixed";
    el.style.top = "6rem";
    el.style.zIndex = "3";
  };

  const unfixTopEl = el => {
    el.style.width = "unset";
    el.style.position = "unset";
    el.style.top = "unset";
    el.style.zIndex = "unset";
  };

  // ON UNMOUNT
  useEffect(() => {
    return () => {
      dispatch({ type: ACTIONS.HIDE_HELLPER_SIDE_NAV });
      GLOBALS.caseNavMounted = false;
      clearTimeout(scrollTimeout);
    };
  }, []);

  const init = useCallback(() => {
    dispatch({ type: ACTIONS.SET_HELPER_NAV_AS_PRESENT });
    getMainData();
  }, [getMainData]);

  // run once on page load
  useEffect(init, []);

  const { score, overview, top_cases, form, nav } = activeCase || {};

  return (
    <NewAppHOC>
      <MainAsideNav onScroll={handleScroll}>
        {activeCase && (
          // <AnimateLayout animate={activeCase} addClass="__n_bs" id="__n_6789689687698">
          <div className="__n_bs" id="__n_6789689687698">
            <Link to="/ui/reviewer/dashboard">
              <Layout flex>
                <div>
                  <Icon
                    iconId="reviewCaseFull"
                    addClass="c1 __n_bi"
                    style={{ marginRight: ".7rem" }}
                  />
                </div>
                <Title tagName="h1" addClass="c16" removeWeight>
                  {intl.formatMessage({ id: "reviewerDashboard" })}
                </Title>
              </Layout>
            </Link>
            <div>
              <Link to={`/ui/reviewer/stage/${activeCase.stage_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="categoriesFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {activeCase.breadcrumbs.stage.title}
                  </Title>
                </Layout>
              </Link>
              <Link to={`/ui/reviewer/collection/${activeCase.collection_id}`}>
                <Layout flex>
                  <div>
                    <Icon iconId="listFull" addClass="c1 __n_bi" />
                  </div>
                  <Title tagName="span" removeWeight addClass="c16">
                    {activeCase.breadcrumbs.collection.title}
                  </Title>
                </Layout>
              </Link>

              <Title
                tagName="span"
                removeWeight
                type="small"
                style={{ marginTop: "1rem", display: "block", marginBottom: ".5rem" }}
              >
                {renderLangString({ id: "$_e5" })}
              </Title>
              <Title tagName="h1">
                {activeCase.code} - {activeCase.title}
              </Title>
            </div>

            <div id="displayScoreCon_12390u13">
              <DisplayScore
                id="483864876597484"
                addClass="c10 bc1"
                score={activeCase.score}
                savedStatus={savedStatus}
                confirmed={activeCase.confirmed}
              />
            </div>

            {!isCounterDone && (
              <TogglePrompt
                msg={[renderLangString({ id: "$_o" }), renderLangString({ id: "$_p" })]}
                btnText={[renderLangString({ id: "$_q" }), renderLangString({ id: "$_r" })]}
                view={isExcluded}
                callback={handleExcludion}
              />
            )}

            <div>
              {!isExcluded && form && (
                <FormioForm
                  formData={form}
                  options={info.default_formio_options}
                  blockFormSubmission={isCounterDone}
                  onChange={handleFormChange}
                  onSave={handleFormSave}
                  hideErrorMsgs
                />
              )}
            </div>

            {activeCase.coll_stats.stats.todo === 0 &&
              !activeCase.coll_stats.confirmed &&
              reviewer && (
                <TogglePrompt
                  confirmer
                  title={[renderLangString({ id: "$_t" }), ""]}
                  msg={[renderLangString({ id: "$_u" }), ""]}
                  url={`${Routes.reviewerCollection().path}/${reviewer.collection}`}
                  btnText={[renderLangString({ id: "$_v" }), ""]}
                  iconID={"celebrate"}
                />
              )}
            {nav && <CarouselNav data={nav} onBtnClick={handleCaroselClick} />}
            <NewButton
              id="btn-19004981"
              onClick={toggleAllCases}
              onKeyDown={toggleHelperNav}
              btnStyle="flat"
              colStyle="gray"
              style={{
                width: "100%",
                textTransform: "uppercase",
                fontWeight: "bold",
                display: "inline-block",
              }}
              value={
                reduxState.app.helperSideNavToggle
                  ? renderLangString({ id: "$_z1" })
                  : renderLangString({ id: "$_z" })
              }
            />

            {top_cases.length > 0 && (
              <ListNav
                type="rating"
                title={renderLangString({ id: "$_w" })}
                linkTo={Routes.reviewerCase().path}
                list={top_cases}
              />
            )}
          </div>
          // </AnimateLayout>
        )}
      </MainAsideNav>
      <Main counter={counterData} onCounterEnd={handleCounterEnd}>
        {overview && (
          // <AnimateLayout animate={overview}>
          <>
            {overview.additional_content && (
              <ContentAccordion
                firstContent={overview.additional_content.collapsed_content}
                secondContent={overview.additional_content.content}
              />
            )}
            <Overview overviewData={overview} readonly={true} />
          </>
          // </AnimateLayout>
        )}
      </Main>
      <HelperAsideNav>
        {nav && (
          <ListNav
            clicked={handleNavItemClick}
            title={renderLangString({ id: "$_a1" })}
            linkTo={Routes.reviewerCase().path}
            type="cases"
            list={nav.cases || []}
          />
        )}
      </HelperAsideNav>
    </NewAppHOC>
  );
}

export default injectIntl(withRouter(Case));
